var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6 22.5C5.45 22.5 4.97933 22.3043 4.588 21.913C4.19667 21.5217 4.00067 21.0507 4 20.5V10.5C4 9.95 4.196 9.47933 4.588 9.088C4.98 8.69667 5.45067 8.50067 6 8.5H7V6.5C7 5.11667 7.48767 3.93767 8.463 2.963C9.43833 1.98833 10.6173 1.50067 12 1.5C13.3833 1.5 14.5627 1.98767 15.538 2.963C16.5133 3.93833 17.0007 5.11733 17 6.5V8.5H18C18.55 8.5 19.021 8.696 19.413 9.088C19.805 9.48 20.0007 9.95067 20 10.5V20.5C20 21.05 19.8043 21.521 19.413 21.913C19.0217 22.305 18.5507 22.5007 18 22.5H6ZM12 17.5C12.55 17.5 13.021 17.3043 13.413 16.913C13.805 16.5217 14.0007 16.0507 14 15.5C14 14.95 13.8043 14.4793 13.413 14.088C13.0217 13.6967 12.5507 13.5007 12 13.5C11.45 13.5 10.9793 13.696 10.588 14.088C10.1967 14.48 10.0007 14.9507 10 15.5C10 16.05 10.196 16.521 10.588 16.913C10.98 17.305 11.4507 17.5007 12 17.5ZM9 8.5H15V6.5C15 5.66667 14.7083 4.95833 14.125 4.375C13.5417 3.79167 12.8333 3.5 12 3.5C11.1667 3.5 10.4583 3.79167 9.875 4.375C9.29167 4.95833 9 5.66667 9 6.5V8.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.a9f3af5551cc6fba24d6883d752e64f8.svg";
export { ForwardRef as ReactComponent };